import { generateSdxl, generateText2Image } from '@/services';
import { useSMutation, testPreventSubmitLink } from '@/utils';
import { toast } from 'react-toastify';

const useGenerativeImage = (
  selectedCommandLine: any,
  setSelectMethodCommandLine: React.Dispatch<any>,
  onFinish: () => void,
) => {
  const { mutate: mutateGenerateSdxl, isLoading: isLoadingSdxl } = useSMutation({
    mutationFn: generateSdxl,
  });
  const { mutate: mutateGenerateText2Image, isLoading: isLoadingText2 } = useSMutation({
    mutationFn: generateText2Image,
  });

  const generateImgSdxl = (data: any) => {
    if (!data.prompt) return;
    const promptInput = data.prompt.replace('/prompt ', '').trim();

    data = data = {
      ...data,
      modelId: selectedCommandLine?.model?.id,
      chat_content: promptInput,
      prompt: promptInput,
    };
    let { lora } = data;
    if (testPreventSubmitLink(promptInput)) {
      toast.error('Prompt not to include links!');
      return;
    }
    if (lora.length > 0) {
      lora = lora.map((lora: any) => `${lora.alias}:${lora.value}`).join(',');
      data = { ...data, lora };
    }
    console.log('🐉 ~ generateImgSdxl ~ data ~ 🚀\n', data);

    const bodyFormData = new FormData();
    for (const k in data) {
      if (data[k] !== '') bodyFormData.append(k, data[k]);
    }

    mutateGenerateSdxl(bodyFormData, {
      onSuccess: () => {
        setSelectMethodCommandLine(null);
        onFinish();
      },
    });
  };

  const generateImgText2Image = (data: any) => {
    if (!data.prompt) return;
    const promptInput = data?.prompt?.slice(10).trim() || '';

    data = data = {
      ...data,
      modelId: selectedCommandLine?.model?.id,
      chat_content: data.prompt,
      prompt: promptInput,
    };
    let { lora } = data;
    if (testPreventSubmitLink(promptInput)) {
      toast.error('Prompt not to include links!');
      return;
    }
    if (lora.length > 0) {
      lora = lora.map((lora: any) => `${lora.alias}:${lora.value}`).join(',');
      data = { ...data, lora };
    }
    console.log('🐉 ~ generateImgText2Image ~ data ~ 🚀\n', data);

    const bodyFormData = new FormData();
    for (const k in data) {
      if (data[k] !== '') bodyFormData.append(k, data[k]);
    }

    mutateGenerateText2Image(bodyFormData, {
      onSuccess: () => {
        setSelectMethodCommandLine(null);
        onFinish();
      },
    });
  };

  const generateImage = (data: any) => {
    if (!selectedCommandLine) return;
    switch (selectedCommandLine?.model?.type) {
      case 'Text2Image':
        generateImgSdxl(data);
        break;
      case 'SDXL':
        generateImgText2Image(data);
        break;
      default:
        generateImgSdxl(data);
        1;
        break;
    }
  };

  return {
    isLoadingSdxl,
    isLoadingText2,
    generateImage,
  };
};

export default useGenerativeImage;
